import "./styles/index.scss";
import { Button, Col, Image, MenuProps, Row } from "antd";
import Search from "antd/es/input/Search";
import { useEffect, useMemo, useState } from "react";
import Assets from "../../../../applications/assets";
import HeaderBtnLogin from "./ButtonLogin";
import HeaderBtnShoppingCard from "./ButtonShoppingCard";
import OrderList from "../Products/components/OrderComponent/OrderList";
import { Dropdown } from "antd";
import { HOME_CATEGORY_CONFIG } from "../../../../applications/useCase/BusinessUseCase/SectionDataUseCase";
import MenuOutlined from "@ant-design/icons/lib/icons/MenuOutlined";

interface HeaderProps {
  activeMenuNav: number;
  filterProduct: string;
  setActiveMenuNav: (id: number) => void;
  setFilterProduct: (value: string) => void;
  selectedSectionId?: string;
  setSelectedSectionId: (val: string) => void;
}

const PLACEHOLDER_TEXT = "Xin chào, bạn cần gì hôm nay?";
const TYPING_SPEED = 100; // ms / ký tự

const WAIT_AFTER_DONE = 3000; // 3s
const DELETING_SPEED = 40;

function Header(props: HeaderProps) {
  const {
    activeMenuNav,
    setActiveMenuNav,
    setFilterProduct,
    setSelectedSectionId,
    selectedSectionId,
    filterProduct,
  } = props;
  const [placeholder, setPlaceholder] = useState("");
  const [open, setOpen] = useState<boolean>(false);

  const categoryMenu: MenuProps["items"] = useMemo(() => {
    return HOME_CATEGORY_CONFIG.map((c) => ({
      key: c.key,
      label: c.label,
      onClick: () => setSelectedSectionId(c.key),
      className: selectedSectionId === c.key ? "dropdown-active-cate" : "",
    }));
  }, [selectedSectionId]);

  useEffect(() => {
    let index = 0;
    let isDeleting = false;
    let timeoutId: any;

    const run = () => {
      timeoutId = setTimeout(
        () => {
          // Typing
          if (!isDeleting) {
            setPlaceholder(PLACEHOLDER_TEXT.slice(0, index + 1));
            index++;

            // Khi gõ xong → chờ 3s rồi chuyển sang xoá
            if (index === PLACEHOLDER_TEXT.length) {
              timeoutId = setTimeout(() => {
                isDeleting = true;
                run();
              }, WAIT_AFTER_DONE);
              return;
            }
          }
          // Deleting
          else {
            setPlaceholder(PLACEHOLDER_TEXT.slice(0, index - 1));
            index--;

            if (index === 0) {
              isDeleting = false;
            }
          }

          run();
        },
        isDeleting ? DELETING_SPEED : TYPING_SPEED,
      );
    };

    run();

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <header className="app-header">
        <div className="app-header_top">
          <div className="header-inner">
            <Row align="middle" className="header-desktop">
              <Col
                md={3}
                lg={3}
                className="header-logo"
                style={{
                  paddingLeft: "6px",
                }}
              >
                <Image src={Assets.AppLogo} width={40} height={36} preview={false} />
              </Col>

              <Col md={12} lg={12} className="header-search">
                <Search
                  placeholder={placeholder}
                  value={filterProduct}
                  onChange={(e) => setFilterProduct(e.target.value)}
                  allowClear
                  size="large"
                />
              </Col>

              <Col md={9} lg={9} className="header-actions">
                <HeaderBtnLogin setActiveMenuNav={setActiveMenuNav} />
                <HeaderBtnShoppingCard setOpen={setOpen} />
              </Col>
            </Row>
          </div>
          {/* Row 1: Logo + Buttons */}
          <Row align="middle" className="header-mobile">
            <Col
              xs={6}
              sm={6}
              style={{
                paddingLeft: "6px",
              }}
            >
              <Image src={Assets.AppLogo} width={40} height={36} preview={false} />
            </Col>

            <Col xs={18} sm={18} className="flex justify-content-end gap-2 pr-2">
              <HeaderBtnLogin setActiveMenuNav={setActiveMenuNav} />
              <HeaderBtnShoppingCard setOpen={setOpen} />
            </Col>
          </Row>

          {/* Row 2: Search */}
          <Row className="header-mobile p-1">
            <Col xs={24}>
              <Search
                placeholder={placeholder}
                value={filterProduct}
                onChange={(e) => setFilterProduct(e.target.value)}
                allowClear
                size="large"
              />
            </Col>
          </Row>
        </div>
        <div className="app-header_menu_nav">
          <Row className="container w-100 h-100 justify-content-center">
            <Col
              xs={24}
              sm={24}
              md={{ span: 18, offset: 3 }}
              lg={{ span: 18, offset: 3 }}
              className="flex h-100 align-items-center gap-2 flex-wrap"
            >
              <Dropdown
                menu={{
                  items: categoryMenu,
                  selectedKeys: selectedSectionId ? [selectedSectionId] : [],
                }}
                trigger={["hover", "click"]}
              >
                <Button
                  className={`menu-nav_btn  ${activeMenuNav === 1 ? "menu-nav_active" : ""} `}
                  onClick={() => setActiveMenuNav(1)}
                >
                  <span className="nav-icon">
                    <MenuOutlined />
                  </span>
                  <span className="nav-text">Danh mục</span>
                </Button>
              </Dropdown>

              <Button
                className={`menu-nav_btn ${
                  activeMenuNav === 2 ? "menu-nav_active" : ""
                } flash-deal-btn`}
                onClick={() => setActiveMenuNav(2)}
              >
                <span className="nav-icon">🎁</span>
                <span className="nav-text">Flash deal</span>
              </Button>
              <Button
                className={`menu-nav_btn ${activeMenuNav === 3 ? "menu-nav_active" : ""}`}
                onClick={() => setActiveMenuNav(3)}
              >
                <span className="nav-icon">☎️</span>
                <span className="nav-text">Liên hệ</span>
              </Button>
            </Col>
          </Row>
        </div>
      </header>
      <OrderList open={open} setOpen={setOpen} />
    </>
  );
}
export default Header;
